export default __webpack_public_path__ + "static/media/ic-down-input.66524aef.svg";